module.exports = __webpack_public_path__ + "img/B_020_4c.a99de607.png";